<div class="grid-12 arm-introduction__info">
    <div class="contact-caption arm-introduction__infomobile">
        <div class="contact-caption--image">
            <img alt="" data-cand-image="assets/images/arm-message.svg" [appAssetSrc]="'assets/images/arm-message.svg'" />
        </div>
        <div class="contact-caption--caption">
            <p>
                {{ 'documentselection.documentlist.footer.contact.text.exp3' | i18n }}
            </p>
            <span>
                {{ 'documentselection.documentlist.footer.contact.info.exp3' | i18n }}
            </span>
        </div>
    </div>
</div>
